import React from "react";
import TherapistSideBar from "../../common/TherapistSidebar/TherapistSidebar";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import PaymentInfo from '../UserTherapyPlanner/PaymentInfo';
import { useTranslation } from "react-i18next"

// Chart.js kayıt işlemi
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

function TherapistPaymentPage() {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen">
      <div className="flex flex-col lg:flex-row">
        <div className="flex">
          <TherapistSideBar />

          <div className="p-3 ml-3 mt-6 sm:p-4">
            <div className="w-[200px] sm:w-[237px]">
              <h1 className="text-[17px] sm:text-[24px] font-poppins font-extrabold text-primary mb-7">
                {t("paymentSettings")}
              </h1>
            </div>
          </div>
        </div>

        <div className="w-full max-w-[765px] mt-4 lg:mt-20 lg:flex-1 p-3 sm:p-4">
          <PaymentInfo customStyle={{ marginBottom: '20px' }} />
        </div>
      </div>
    </div>
  );
}

export default TherapistPaymentPage;